import { render, staticRenderFns } from "./SponsoredRecommendationMultiTitleHomeGlobal.vue?vue&type=template&id=4883e9c5&scoped=true"
import script from "./SponsoredRecommendationMultiTitleHomeGlobal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationMultiTitleHomeGlobal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationMultiTitleHomeGlobal.vue?vue&type=style&index=0&id=4883e9c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4883e9c5",
  null
  
)

export default component.exports